// const liveLink = "https://tradeunlisting.herokuapp.com";
export const liveLink = "https://api.tradeunlisted.com";
// export const liveLink = "https://apiv1tradeunlisted.itcodehelp.com";
// export const liveLink = "https://trade-dev-backend.vercel.app";
// export const liveLink = "http://18.144.49.20:5000";
// export const liveLink = "https://e870-2405-201-2029-a83c-84bc-b159-d1f6-aec7.ngrok-free.app";
// const liveLink = "https://apiv1tradeunlisted.itcodehelp.com";

// const liveLink = "http://4636-2405-201-2029-a83c-1136-88eb-7ab3-704b.ngrok.io";
// const liveLink = "http://5421-123-201-1-12.ngrok.io";

export const adminBaseUrl = `${liveLink}/v1/admin`;
export const imageUrl = `${liveLink}/v1/image`;
export const userBaseUrl = `${liveLink}/v1/user`;
export const otpUrl = `${liveLink}/v1/otp`;
export const commonBaseUrl = `${liveLink}/v1/common`;
export const cpBaseUrl = `${liveLink}/v1/cp`;
export const nextBaseUrl = `${liveLink}/v1/nextTrade_Admin`;
export const nexttradBaseUrl = `${liveLink}/v1/nextTrade`;
         